import type qs from 'qs';

import type { NavigateOptions } from '../use-navigate';

import type { Lens } from './lens';
import { useSetUrlQueryLens } from './use-set-url-query-lens';
import { useUrlQueryValue } from './use-url-query-value';

/**
 * Use a lens to get and set URL query parameters.
 *
 * Returns the current value and setter function,
 * similar to what `useState` returns.
 */
export function useUrlQueryLens<A, B>(
	lens: Lens<qs.ParsedQs, unknown, A, B>,
	navigateOptions?: NavigateOptions
) {
	return [
		useUrlQueryValue({ lens }),
		useSetUrlQueryLens(lens, navigateOptions),
	] as const;
}
